module.exports = __webpack_public_path__ + "static/img/jh-icon.8495c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jh-icon.png
// module id = F5Ij
// module chunks = 1